import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2038b61a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "member_tabCard" }
const _hoisted_2 = { class: "tabs flex-cen" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "tab-content" }
const _hoisted_6 = { class: "fee-title" }
const _hoisted_7 = { class: "fee-subTitle" }
const _hoisted_8 = { class: "fee-title" }
const _hoisted_9 = { class: "fee-subTitle" }
const _hoisted_10 = { class: "card-Title" }
const _hoisted_11 = { class: "flex-cen-ter" }
const _hoisted_12 = {
  key: 2,
  class: "flex-cen"
}
const _hoisted_13 = ["href"]
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { class: "concat" }
const _hoisted_16 = { class: "title" }
const _hoisted_17 = { class: "flex-ter-cen concat-method" }
const _hoisted_18 = ["href"]
const _hoisted_19 = ["src"]
const _hoisted_20 = {
  key: 0,
  style: {"font-size":"12px","color":"#989898","padding-left":"24px"}
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-a-24gf-telephone" }, null, -1))
const _hoisted_22 = {
  key: 0,
  style: {"font-size":"12px","color":"#989898","padding-left":"20px"}
}
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-a-bianzu5" }, null, -1))

import { t, lang } from '@/plugins/i18n'
import { MembershipTemplatePriceListVO } from '@/service/settlement'
import { isEN, isJA, isKO, useSite } from '@/store'
import { getCurrentMonetaryUnit } from '@/util/useYan'
import { ref, watch, computed, onMounted } from 'vue'
import MemberCard from './MemberCard.vue'
import icon_line from '@/assets/image/vipImg/icon_line.png'
import kakao_footer from '@/assets/image/footer/kakao_footer.png'
import MemberContrast from './MemberContrast.vue'
import { useStore } from 'vuex'
import { useRoute } from 'vue-router'
interface Props {
  comboList: MembershipTemplatePriceListVO[],
  openModal: (params: any) => void
  /** 特殊会员 */
  isSpecial?: boolean,
  changeTab?: any,
  memberTab?: any
}
export interface CardItem {
  level: number
  name: string
  recommonBuy: string
  fee: number
  logo?: string
  desc: {
    title: string
    tag?: string
    disabled?: boolean
  }[]
  purchase?: any[]
  brand?: any[]
  efficiency?: any[]
  combo: MembershipTemplatePriceListVO
}


export default /*#__PURE__*/_defineComponent({
  props: {
    comboList: { type: Array, required: true },
    openModal: { type: Function, required: true },
    isSpecial: { type: Boolean, required: false },
    changeTab: { type: null, required: false },
    memberTab: { type: null, required: false }
  },
  setup(__props: any) {

const props = __props as {
  comboList: MembershipTemplatePriceListVO[],
  openModal: (params: any) => void
  /** 特殊会员 */
  isSpecial?: boolean,
  changeTab?: any,
  memberTab?: any
}
const store = useStore()



const user = computed(() => store.getters.user)

const concatInfo = computed(() => {
  return {
    ja: {
      icon: icon_line,
      title: t('LINE 查询'),
      email: 'info@theckb.com',
      phone: '03-4446-7313',
      url: 'https://line.me/R/ti/p/@962puoaf?oat_content=url'
    },
    en: {
      email: 'ckbenglish@sniffgroup.com',
      phone: '+86 13783507302'
    },
    ko: {
      icon: kakao_footer,
      title: t('LINE 查询'),
      email: 'Korea@theckb.com',
      phone: '010-7352-2830',
      url: 'https://pf.kakao.com/_uzWxoxj'
    }
  }[useSite()]
})

// 料金详细url链接
const feeUrl = isJA() ? 'https://www.theckb.com/price/plan/' : isKO() ? 'https://korea.theckb.com/price#2' : 'https://www.theckbofficial.com/price'

const tabs = [
  {
    title: t('个人客户'),
    icon: 'https://static-s.theckb.com/BusinessMarket/Client/member/member_tab1.png',
    name: 'person'
  },
  {
    title: t('企业客户'),
    icon: 'https://static-s.theckb.com/BusinessMarket/Client/member/member_tab2.png',
    name: 'company'
  }
] as const

const personCard = ref<CardItem[]>([
  {
    level: 0,
    name: '免费会员',
    recommonBuy: t('参考购买金额：每月不超过2万日元'),
    fee: 0,
    desc: [
      {
        title: t('EC 网站商品采购'),
        tag: '2次/月'
      }, {
        title: t('类似图片搜索'),
        tag: '3次/天'
      }, {
        title: t('日本标准质检')
      }, {
        title: t('品牌代理销售权'),
        disabled: true
      }, {
        title: t('与日本 EC 网站系统联动和代发货服务'),
        disabled: true
      }, {
        title: t('自定义选项和材料使用'),
        disabled: true
      }, {
        title: t('简单 OEM 支持'),
        disabled: true
      }, {
        title: t('系统聊天支持')
      }
    ],
    combo: {
      priceName: t('免费会员'),
      discountActualPrice: 0
    }
  },
  {
    level: 2,
    name: '标准舱',
    recommonBuy: t('参考购买金额：30万～100万日元/月'),
    fee: 0,
    logo: 'https://static-s.theckb.com/BusinessMarket/Client/member/member_level_2.png',
    desc: [
      {
        title: t('EC 网站商品采购'),
        tag: isJA() ? '无限制' : ''
      }, {
        title: t('类似图片搜索2'),
        tag: isJA() ? '无限制' : ''
      }, {
        title: t('日本标准质检')
      }, {
        title: t('品牌代理销售权')
      }, {
        title: t('与日本 EC 网站系统联动和代发货服务')
      }, {
        title: t('自定义选项和材料使用')
      }, {
        title: t('简单 OEM 支持')
      }, {
        title: t('系统聊天和 LINE 专属支持')
      }
    ],
    combo: {
      priceName: t('标准舱')
    }
  }
])

const companyCard = ref<CardItem[]>([
  {
    level: 3,
    name: '',
    recommonBuy: t('参考购买金额：每月100万~300万日元'),
    fee: 0,
    logo: 'https://static-s.theckb.com/BusinessMarket/Client/member/member_level_3.png',
    desc: [
      {
        title: t('包含标准计划的所有服务')
      }, {
        title: isJA() ? t('完全支持OEM/ODM') : t('完全支持OEM/ODM1')
        // tag: '4次/月'
      }, {
        title: t('品牌独占销售权及优惠价格采购')
      },
      {
        title: t('1对1特别商品提案'),
        tag: '1次/月'
      }, {
        title: t('系统聊天及专属Chatwork群组')
      }
    ],
    combo: {}
  }, {
    level: 4,
    name: '',
    recommonBuy: t('参考购买金额：每月300万日元以上'),
    fee: 0,
    logo: 'https://static-s.theckb.com/BusinessMarket/Client/member/member_level_4.png',
    desc: [
      {
        title: t('包含商务计划的所有服务')
      }, {
        title: t('完全支持OEM/ODM'),
        tag: '6次/月'
      }, {
        title: t('品牌独占销售权及优惠价格采购')
      }, {
        title: t('1对1特别商品提案'),
        tag: '2次/月2'
      }, {
        title: t('系统聊天及专属Chatwork群组')
      }
    ],
    combo: {}
  }
])

// 当前活动
const newMemberActivity = computed(() => store.state.status.newMemberActivity.id ? store.state.status.newMemberActivity : false)

watch(() => props.comboList, (val) => {
  console.log(props.comboList, 'props.comboList')

  if (isJA()) {
    val.forEach(item => {
      if (item.templateLevel === 2) {
        personCard.value[1].combo = item
        personCard.value[1].level = 2
      } else if (item.templateLevel === 3) {
        companyCard.value[0].level = 3
        companyCard.value[0].combo = item
      } else if (item.templateLevel === 4) {
        companyCard.value[1].level = 4
        companyCard.value[1].combo = item
      }
    })
  } else {
    val.forEach(item => {
      if (item.templateLevel === 1) {
        personCard.value[1].level = 1
        personCard.value[1].combo = item
      } else if (item.templateLevel === 2) {
        companyCard.value[0].level = 2
        companyCard.value[0].combo = item
      } else if (item.templateLevel === 3) {
        companyCard.value[1].level = 3
        companyCard.value[1].combo = item
      }
    })
  }
})
// 货币单位
const currentMonetaryUnit = getCurrentMonetaryUnit()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(tabs), (tab) => {
        return (_openBlock(), _createElementBlock("div", {
          key: tab.name,
          class: _normalizeClass(["tab-title flex-cen-ter cursor-pt", { active: __props.memberTab === tab.name }]),
          onClick: ($event: any) => (props.changeTab(tab.name))
        }, [
          _createElementVNode("img", {
            class: "tab-icon",
            src: tab.icon,
            alt: ""
          }, null, 8, _hoisted_4),
          _createTextVNode(" " + _toDisplayString(tab.title), 1)
        ], 10, _hoisted_3))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_5, [
      (__props.memberTab === 'person')
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(t)('个人客户（主要是个体工商户）的费率计划')), 1),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", null, _toDisplayString(_unref(t)('免费计划和付费标准计划中提供的服务和福利的详细比较，')), 1),
              _createElementVNode("div", null, _toDisplayString(_unref(t)('找到支持您业务增长的最佳计划。')), 1)
            ])
          ], 64))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(t)('商业和企业客户的费率计划')), 1),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", null, _toDisplayString(_unref(t)('商业计划和付费的第一计划提供的服务没有太大区别，但根据购买金额的不同，费用差异很大。 查看这两个计划的基本费用和成本，以找到更有效地支持您的业务的最佳计划。')), 1)
            ])
          ], 64)),
      _createElementVNode("div", _hoisted_10, _toDisplayString(_unref(t)('基本功能')), 1),
      _createElementVNode("div", _hoisted_11, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.memberTab === 'person' ? personCard.value : companyCard.value, (item) => {
          return (_openBlock(), _createElementBlock(_Fragment, {
            key: item.level
          }, [
            (item.combo?.priceName)
              ? (_openBlock(), _createBlock(MemberCard, {
                  key: 0,
                  onOpen: __props.openModal,
                  memberCardInfo: item
                }, null, 8, ["onOpen", "memberCardInfo"]))
              : _createCommentVNode("", true)
          ], 64))
        }), 128))
      ]),
      (!_unref(isEN)())
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _createElementVNode("a", {
              class: "fee-detail",
              href: _unref(feeUrl),
              target: "_blank",
              style: {"text-decoration":"underline"}
            }, _toDisplayString(_unref(t)('料金詳細')) + " >", 9, _hoisted_13)
          ]))
        : _createCommentVNode("", true)
    ]),
    (!__props.isSpecial)
      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, _toDisplayString(_unref(t)('联系方式')), 1),
            _createElementVNode("div", _hoisted_17, [
              (_unref(concatInfo)?.url)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    href: _unref(concatInfo)?.url,
                    target: "_blank"
                  }, [
                    _createElementVNode("div", null, [
                      _createElementVNode("img", {
                        class: "icon",
                        src: _unref(concatInfo).icon,
                        alt: ""
                      }, null, 8, _hoisted_19),
                      _createElementVNode("span", null, _toDisplayString(_unref(concatInfo).title), 1)
                    ]),
                    (_unref(isJA)())
                      ? (_openBlock(), _createElementBlock("div", _hoisted_20, " 受付時間 平日:10:00~13:00, 14:15~19:00 "))
                      : _createCommentVNode("", true)
                  ], 8, _hoisted_18))
                : _createCommentVNode("", true),
              _createElementVNode("div", null, [
                _createElementVNode("div", null, [
                  _hoisted_21,
                  _createElementVNode("span", null, _toDisplayString(_unref(concatInfo).phone), 1)
                ]),
                (_unref(isJA)())
                  ? (_openBlock(), _createElementBlock("div", _hoisted_22, " 受付時間 平日:10:00~13:00, 14:15~19:00 "))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("div", null, [
                  _hoisted_23,
                  _createElementVNode("span", null, _toDisplayString(_unref(concatInfo).email), 1)
                ])
              ])
            ])
          ]),
          _createVNode(MemberContrast, {
            onOpen: __props.openModal,
            onChangeTab: props.changeTab,
            memberTab: props.memberTab,
            contrast: __props.memberTab === 'person' ? personCard.value : companyCard.value
          }, null, 8, ["onOpen", "onChangeTab", "memberTab", "contrast"])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})